import type { FC } from 'react';

import ArchivedVersion from '../ArchivedVersion.jsx';
import MediaPlanVersion from '../MediaPlanVersion.jsx';

type Props = {
  isArchivedVersion: boolean;
  versionName: string;
  isDisabled: boolean;
  handleOpenVersioning: () => void;
};

const Archived: FC<Props> = ({
  isArchivedVersion,
  versionName,
  isDisabled,
  handleOpenVersioning,
}) => {
  if (isArchivedVersion) {
    return <ArchivedVersion version={versionName} />;
  }

  return (
    <MediaPlanVersion
      version={versionName}
      isClickable
      onClick={handleOpenVersioning}
      disabled={isDisabled}
    />
  );
};

export default Archived;
